import { Injectable } from '@angular/core';
import { SupplierApiService } from '@cms/apis';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { exhaustMap, map } from 'rxjs';
import { SupplierAction } from '../actions';
import { FnWithCompany, WithCompany } from '@cms/backgrounds/switch-company';

@Injectable()
export class SupplierEffect {
  loadItem$ = createEffect(() => {
    return this._actions$.pipe(
      ofType(SupplierAction.loadItem),
      exhaustMap(action => {
        return this.fetch(action.id).pipe(map(item => SupplierAction.loadItemSuccess({ item })));
      })
    );
  });

  @FnWithCompany()
  fetch(id: number, @WithCompany() option: Record<string, any> = {}) {
    return this._apiService.get(id, option);
  }

  constructor(private _apiService: SupplierApiService, private _actions$: Actions, private _store: Store) {}
}
